import { useEffect, useState } from 'react';
import { IUser } from '../../type';

interface WelcomePopupProps {
  user: IUser;
  onClose: () => void;
  /** Thoát / dismiss — có thể kèm logout (xóa localStorage) */
  onExit?: () => void;
}

export default function WelcomePopup({ user, onClose, onExit }: WelcomePopupProps) {
  const [visible, setVisible] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  const dismiss = (exit = false) => {
    if (exit && onExit) {
      onExit();
    } else {
      onClose();
    }
    setIsClosing(true);
    window.setTimeout(() => {
      setVisible(false);
    }, 300);
  };

  useEffect(() => {
    // Auto hide after 5 seconds (chỉ đóng welcome, không xóa session)
    const timer = setTimeout(() => dismiss(false), 5000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;

  return (
    <div className={`welcome-popup ${isClosing ? 'closing' : ''}`}>
      <div className="welcome-popup-content">
        <span>{user.username || user.email}, Welcome</span>
        <button
          type="button"
          className="welcome-popup-exit"
          onClick={() => dismiss(true)}
          aria-label="Thoát"
        >
          Thoát
        </button>
      </div>
    </div>
  );
}
